import React from 'react';
import { Avatar } from '@carnica/ui-kit';
import { LogoBeelineColor } from '@carnica/graphics';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var LogoButton = function LogoButton() {
  return /*#__PURE__*/React.createElement("a", {
    "aria-label": "logo",
    className: cn('link'),
    href: "/",
    "data-t-id": "HeaderButtons-LogoButton"
  }, /*#__PURE__*/React.createElement(Avatar, {
    logo: LogoBeelineColor
  }));
};